import _ from 'lodash'
import { getUniqueFileTypes } from '../../utils/file-types';

const initialState = () => ({
  products: JSON.parse(localStorage.getItem('cartProducts')) || [],
  address: JSON.parse(localStorage.getItem('cartAddress')) || { country: null, state: null }
})

const state = initialState()

const actions = {
  addProduct (context, productData) {
    if (!productData.file_storage) {
      productData.file_storage = {}
    }

    if (!productData.cp_files) {
      productData.cp_files = {
        link: {},
        upload: {},
        dropbox: {},
      }

      productData.required_files = getUniqueFileTypes(productData.cpProductInfo, productData.cp_product_options);

      for (let file of productData.required_files) {
        productData.cp_files.link[file.type] = null
        productData.cp_files.upload[file.type] = {}
        productData.cp_files.dropbox[file.type] = {}
        productData.file_storage[file.type] = 'link'
      }
    }

    context.commit('addProduct', productData)
  },

  removeProduct (context, index) {
    context.commit('removeProduct', index)
  },

  editProduct (context, data) {
    data.productData['file_storage'] = {}
    data.productData['cp_files'] = {
      link: {},
      upload: {},
      dropbox: {}
    }

    data.productData.required_files = getUniqueFileTypes(data.productData.cpProductInfo, data.productData.cp_product_options);

    for (let file of data.productData.required_files) {
      data.productData.cp_files.link[file.type] = null
      data.productData.cp_files.upload[file.type] = {}
      data.productData.cp_files.dropbox[file.type] = {}
      data.productData.file_storage[file.type] = 'link'
    }

    context.commit('editProduct', data)
  },

  clearCart (context) {
    context.commit('clearCart')
  },

  updateAddress (context, addressData) {
    context.commit('setAddress', addressData)
  },

  setCountry (context, country) {
    let address = context.rootGetters['cart/address']
    address.country = country
    context.commit('setAddress', address)
  },

  setState (context, state) {
    let address = context.rootGetters['cart/address']
    address.state = state
    context.commit('setAddress', address)
  }
}

const mutations = {
  addProduct (state, productData) {
    state.products.push(productData)
    localStorage.setItem('cartProducts', JSON.stringify(state.products))
  },
  removeProduct (state, index) {
    state.products.splice(index, 1)
    localStorage.setItem('cartProducts', JSON.stringify(state.products))
  },
  editProduct (state, data) {
    state.products.splice(data.productIndex, 1, data.productData)
    localStorage.setItem('cartProducts', JSON.stringify(state.products))
  },
  clearCart (state) {
    state.products = []
    state.address = { country: state.address.country, state: state.address.state }
    localStorage.setItem('cartProducts', JSON.stringify(state.products))
    localStorage.setItem('cartAddress', JSON.stringify(state.address))
  },

  setAddress (state, addressData) {
    state.address = addressData
    localStorage.setItem('cartAddress', JSON.stringify(state.address))
  }
}

const getters = {
  products: state => {
    // Predefine file storage type for products.
    for (let productData of state.products) {
      if (typeof productData.file_storage !== 'object' || !productData.file_storage) {
        productData.file_storage = {}
        for (let file of productData.cpProductInfo.files) {
          productData.file_storage[file.type] = 'link'
        }

        localStorage.setItem('cartProducts', JSON.stringify(state.products))
      }
    }

    return state.products
  },

  country: state => {
    return state.address.country
  },

  state: state => {
    return state.address.state
  },

  address: state => {
    return state.address
  },

  countFilesToUpload: state => {
    let count = 0

    for (let product of state.products) {
      for (let file of getUniqueFileTypes(product.cpProductInfo, product.cp_product_options)) {
        if (product.file_storage[file.type] === 'upload') {
          count++
        }
      }
    }

    return count
  },

  itemsForOrderSubmission: (state, context, rootState, rootGetters) => {
    const quotes = context.getQuotes
    let items = _.cloneDeep(rootGetters['cart/itemsForPriceCheck'])

    for (let [index, product] of state.products.entries()) {
      items[index]['quote'] = quotes[index + 1]

      if (product.type !== 'stock') {
        items[index]['files'] = []
        let orderItemFiles = product.cp_files.link

        for (let type in orderItemFiles) {
          if (product.file_storage[type] === 'original_file') {
            orderItemFiles[type] = product.cp_files.original[type]
          } else if (product.file_storage[type] === 'dropbox') {
            orderItemFiles[type] = product.cp_files.dropbox[type].link
          }
        }

        for (let type in orderItemFiles) {
          items[index]['files'].push({
            type: type,
            url: orderItemFiles[type],
            md5sum: '_____________NO_MD5_____________'
          })
        }
      } else {
        items[index]['type'] = 'stock'
      }
    }

    return items
  },

  getQuotes: (state, context, rootState, rootGetters) => {
    const quotes = rootGetters['cpOrder/quotes']
    const cpOrderShipping = rootGetters['cpOrder/cpOrderShipping']

    let result = {}
    for (let key in quotes) {
      for (let item of cpOrderShipping[key].items) {
        result[item.reference] = quotes[key]
      }
    }

    return result
  },

  itemsForPriceCheck: state => {
    let items = []

    for (let [key, product] of state.products.entries()) {
      let item = {
        'reference': key + 1,
        'product_reference': product.cp_product_reference,
        'count': product.quantity,
        'options': []
      }

      let options = []
      for (let key in product.cp_product_options) {
        if (key === 'count_pages') {
          options.push({
            'option_reference': 'total_pages',
            'count': product.cp_product_options[key]
          })
        } else if (['total_pages', 'archive_total_files'].indexOf(key) !== -1) {
          options.push({
            'option_reference': key,
            'count': product.cp_product_options[key]
          })
        } else {
          options.push({
            'option_reference': product.cp_product_options[key],
            'count': 1
          })
        }
      }

      item.options = options
      items.push(item)
    }
    return items
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
